import { createSlice } from "@reduxjs/toolkit";
import authService from "../services/authService";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    admin: null,
    isAuthenticated: false,
  },
  reducers: {
    loginSuccess: (state, action) => {
      state.admin = action.payload;
      state.isAuthenticated = true;
    },
    logoutSuccess: (state) => {
      state.admin = null;
      state.isAuthenticated = false;
      authService.logout();
    },
  },
});

export const { loginSuccess, logoutSuccess } = authSlice.actions;
export default authSlice.reducer;
